import { HTMLAttributes, ReactNode } from "react";
import "./Badge.css";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: "success" | "warning" | "danger" | "neutral" | "accent";
  icon?: ReactNode;
}

export function Badge({ tone = "neutral", icon, className, children, ...rest }: BadgeProps) {
  return (
    <span className={["nx-badge", `nx-badge--${tone}`, className].filter(Boolean).join(" ")} {...rest}>
      {icon}
      {children}
    </span>
  );
}
